import { Card, CardContent } from "../components/ui/card";
import imgAkshayKumar from '../../../assets/images/landing-page/celebrity-image/Akshay Kumar.webp';
import imgAlayaF from '../../../assets/images/landing-page/celebrity-image/Alaya F.webp';
import imgAnjaliAnand from '../../../assets/images/landing-page/celebrity-image/Anjali Anand.webp';
import imgAnjiniDhawan from '../../../assets/images/landing-page/celebrity-image/Anjini Dhawan.webp';
import imgAvneetKaur from '../../../assets/images/landing-page/celebrity-image/Avneet Kaur.webp';
import imgAyushmannKhurrana from '../../../assets/images/landing-page/celebrity-image/Ayushmann Khurrana.webp';
import imgBobbyDeol from '../../../assets/images/landing-page/celebrity-image/Bobby Deol.webp';
import imgDaisyShah from '../../../assets/images/landing-page/celebrity-image/Daisy Shah.webp';
import imgDianaPenty from '../../../assets/images/landing-page/celebrity-image/diana penty.webp';
import imgGeetaBasra from '../../../assets/images/landing-page/celebrity-image/Geeta Basra.webp';
import imgHellyShah from '../../../assets/images/landing-page/celebrity-image/Helly Shah.webp';
import imgKrystleD_Souza from '../../../assets/images/landing-page/celebrity-image/Krystle D_Souza.webp';
import imgNargisFakhri from '../../../assets/images/landing-page/celebrity-image/Nargis Fakhri.webp';
import imgNawazuddinSiddiqui from '../../../assets/images/landing-page/celebrity-image/nawazuddin siddiqui.webp';
import imgNushrrattBharuccha from '../../../assets/images/landing-page/celebrity-image/Nushrratt Bharuccha.webp';
import imgPrajaktaKohli from '../../../assets/images/landing-page/celebrity-image/Prajakta Kohli.webp';
import imgRidhimaPandit from '../../../assets/images/landing-page/celebrity-image/Ridhima Pandit.webp';
import imgRjDevangana from '../../../assets/images/landing-page/celebrity-image/Rj Devangana.webp';
import imgShalinBhanot from '../../../assets/images/landing-page/celebrity-image/Shalin Bhanot.webp';
import imgSunnySingh from '../../../assets/images/landing-page/celebrity-image/Sunny Singh.webp';
import imgVaaniKapoor from '../../../assets/images/landing-page/celebrity-image/Vaani Kapoor.webp';
import imgZayedKhan from '../../../assets/images/landing-page/celebrity-image/Zayed Khan.webp';

import imgAkanksha from '../../../assets/images/landing-page/celebrity-image/Akanksha-Sharma.jpg';
import imgAnuradha from '../../../assets/images/landing-page/celebrity-image/Anuradha-Paudwal.jpg';
import imgDiksha from '../../../assets/images/landing-page/celebrity-image/Diksha-Singh.jpg';
import imgKiara from '../../../assets/images/landing-page/celebrity-image/Kiara.jpg';
import imgMalaika from '../../../assets/images/landing-page/celebrity-image/Malaika-Arora.jpg';
import imgPundrik from '../../../assets/images/landing-page/celebrity-image/Pundrik-Goswami.jpg';
import imgShilpa from '../../../assets/images/landing-page/celebrity-image/Shilpa-Shetty.jpg';
import imgSonu from '../../../assets/images/landing-page/celebrity-image/Sonu-sood.jpg';
import imgAmeesha from '../../../assets/images/landing-page/celebrity-image/ameesha-patel.jpg';

const images = [
    { src: imgAkshayKumar, alt: 'Akshay Kumar' },
    { src: imgAlayaF, alt: 'Alaya F' },
    { src: imgAnjaliAnand, alt: 'Anjali Anand' },
    { src: imgAnjiniDhawan, alt: 'Anjini Dhawan' },
    { src: imgAvneetKaur, alt: 'Avneet Kaur' },
    { src: imgAyushmannKhurrana, alt: 'Ayushmann Khurrana' },
    { src: imgBobbyDeol, alt: 'Bobby Deol' },
    { src: imgDaisyShah, alt: 'Daisy Shah' },
    { src: imgDianaPenty, alt: 'Diana Penty' },
    { src: imgGeetaBasra, alt: 'Geeta Basra' },
    { src: imgHellyShah, alt: 'Helly Shah' },
    { src: imgKrystleD_Souza, alt: 'Krystle D_Souza' },
    { src: imgNargisFakhri, alt: 'Nargis Fakhri' },
    { src: imgNawazuddinSiddiqui, alt: 'Nawazuddin Siddiqui' },
    { src: imgNushrrattBharuccha, alt: 'Nushrratt Bharuccha' },
    { src: imgPrajaktaKohli, alt: 'Prajakta Kohli' },
    { src: imgRidhimaPandit, alt: 'Ridhima Pandit' },
    { src: imgRjDevangana, alt: 'Rj Devangana' },
    { src: imgShalinBhanot, alt: 'Shalin Bhanot' },
    { src: imgSunnySingh, alt: 'Sunny Singh' },
    { src: imgVaaniKapoor, alt: 'Vaani Kapoor' },
    { src: imgZayedKhan, alt: 'Zayed Khan' },

    { src: imgAkanksha, alt: 'Akanksha Sharma' },
    { src: imgAnuradha, alt: 'Anuradha Paudwal' },
    { src: imgDiksha, alt: 'Diksha Singh' },
    { src: imgKiara, alt: 'Kiara' },
    { src: imgMalaika, alt: 'Malaika Arora' },
    { src: imgPundrik, alt: 'Pundrik Goswami' },
    { src: imgShilpa, alt: 'Shilpa Shetty' },
    { src: imgSonu, alt: 'Sonu Sood' },
    { src: imgAmeesha, alt: 'Ameesha Patel' }
];


const CelebrityExperiences = () => {
    return (
        <div className="relative w-full overflow-hidden">
            <div className="flex w-max animate-marquee_slow space-x-6 select-none">
                {[...images, ...images].map((img, idx) => (
                    <div key={idx} className="min-w-[150px]">
                        <img loading="lazy" src={img?.src} alt={img?.alt} className="h-96 w-80 object-fill rounded-md shadow-md border border-gray-300" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CelebrityExperiences;